module.exports = __webpack_public_path__ + "img/home.ae23eaaf.svg";